import { HP, legSwing, pt } from '../enemy-parts';
/* ============================================================
   家族 LADLE 勺 —— 蹲坐底座＋上翹長件
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     MÖRSER  vio 臼砲　曲射・壓制
     HAKEN   amb 鉤　牽引・拉近
     BAKE    azu 信標　護盾・增益
     ZUNGE   red 舌　深層・鞭擊

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var LADLE = [
  /* ─ 4 ─────────────────────────────────────────────────────────
     MÖRSER 臼砲 —— 剪影＝「勺」。斜上方一根粗管是全表唯一往上長的東西。
     紫＝地面預警圈。牠停下來才開火，所以停下＝倒數開始。 */
  {
    id:'morser', fam:'ladle', code:'MÖRSER', zh:'臼砲', role:'曲射・壓制', tint:'vio',
    sil:'蹲坐＋上翹粗管', h:1.22, w:0.96, wt:1.4,
    spd:1.15, turn:1.5, gait:1.6, rng:6.0, tTel:0.85, tAtk:0.30, tRec:1.10,
    q0:{lg:1, bl:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'散射', q:{bl:0.80}, sp:1.25, sc:0.90},
          {n:'長管', q:{bl:1.45}, sp:0.78, sc:1.10}],
    parts:[
      pt('bev','dark', [0.84,0.32,0.84],[0,0.22,0]),
      pt('tor','trim', [0.82,0.82,0.55],[0,0.41,0],[HP,0,0], function(P,o){ P.rz += o.t*0.5; }),
      pt('cyl','armor',[0.35,1.02,0.35],[0,0.76,-0.06],[0.62,0,0], function(P,o){
          P.sy *= o.q.bl;
          P.rx -= o.tel*0.34;                        // 抬管＝預備動作
          P.y  -= o.atk*0.22; P.z -= o.atk*0.16; }), // 後座：沿砲管軸退，不是往下退
      pt('tor','glow', [0.46,0.46,0.7],[0,1.17,0.24],[0.62-HP,0,0], function(P,o){
          var k = 1 + 1.8*o.tel - 0.4*o.atk;
          P.sx *= k; P.sy *= k;
          // 砲口跟著管尖走：長管往前伸、抬管把尖端往上前送、後座整根退
          P.y += (o.q.bl-1)*0.42 + o.tel*0.075 - o.atk*0.22;
          P.z += (o.q.bl-1)*0.30 - o.tel*0.155 - o.atk*0.16;
          P.rx -= o.tel*0.34; }),
      pt('cyl','trim', [0.16,0.52,0.16],[ 0.44,0.22,0.22],[0.32,0,-0.44], function(P,o){
          P.rz -= o.tel*0.20; }),
      pt('cyl','trim', [0.16,0.52,0.16],[-0.44,0.22,0.22],[0.32,0, 0.44], function(P,o){
          P.rz += o.tel*0.20; }),
      pt('box','dark', [0.48,0.30,0.32],[0,0.58,-0.48],[0.14,0,0])
    ],
    ex:[ pt('box','armorE',[0.94,0.16,0.60],[0,0.44,-0.30],[0.20,0,0]),
         pt('cyl','armorE',[0.20,0.44,0.20],[ 0.46,0.62,-0.30],[0.2,0,0.2]),
         pt('cyl','armorE',[0.20,0.44,0.20],[-0.46,0.62,-0.30],[0.2,0,-0.2]),
         pt('tor','glowE',[0.60,0.60,0.6],[0,0.41,0],[HP,0,0]),
         pt('box','armorE',[0.16,0.34,0.16],[0,0.92,-0.56],[0.3,0,0]) ],
    pose:function(o){
      o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv - o.tel*0.05;
      o.rp = 0.04*Math.sin(o.ph*Math.PI * 2)*o.mv + o.atk*0.16;
      o.rr = 0;
      o.rz = -o.atk*0.14;
    }
  },
  /* ── 家族 LADLE 勺 ── 蹲坐底座＋往斜上長出去的長件。vio 是 MÖRSER。 */
  {
    id:'haken', fam:'ladle', code:'HAKEN', zh:'鉤', role:'牽引・拉近', tint:'amb',
    sil:'蹲坐＋上翹鉤臂', h:1.24, w:0.92, wt:0.8,
    spd:1.2, turn:1.6, gait:1.6, rng:7.4, tTel:0.78, tAtk:0.45, tRec:1.15,
    q0:{lg:1, am:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'速鉤', q:{am:0.80}, sp:1.34, sc:0.90},
          {n:'長鉤', q:{am:1.42}, sp:0.72, sc:1.14}],
    parts:[
      pt('bev','dark', [0.72,0.42,0.76],[0,0.30,0]),
      pt('box','armor',[0.56,0.30,0.50],[0,0.60,-0.08],[-0.16,0,0]),
      pt('cyl','armor',[0.19,0.94,0.19],[0,0.94,0.24],[-0.62,0,0], function(P,o){
          P.sy *= o.q.am; P.y += (o.q.am-1)*0.30; P.z += (o.q.am-1)*0.22;
          P.rx += o.tel*0.34 - o.atk*0.70; }),
      pt('cone','glow',[0.24,0.34,0.24],[0,1.32,0.56],[-2.0,0,0], function(P,o){
          P.y += (o.q.am-1)*0.62; P.z += (o.q.am-1)*0.46;
          P.z += o.atk*0.55; P.y -= o.atk*0.30;
          var k = 1 + 0.8*o.tel; P.sx*=k; P.sz*=k; }),
      pt('bev','trim', [0.26,0.26,0.62],[ 0.36,0.13,0.06], null, legSwing( 1,0.13,0.18)),
      pt('bev','trim', [0.26,0.26,0.62],[-0.36,0.13,0.06], null, legSwing(-1,0.13,0.18))
    ],
    ex:[ pt('cyl','armorE',[0.24,0.36,0.24],[ 0.34,0.62,-0.16],[HP,0,0]),
         pt('cyl','armorE',[0.24,0.36,0.24],[-0.34,0.62,-0.16],[HP,0,0]) ],
    pose:function(o){
      o.ry = 0.02*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.04 + 0.04*o.mv - o.tel*0.14 + o.atk*0.22;
    }
  },
  {
    id:'bake', fam:'ladle', code:'BAKE', zh:'信標', role:'護盾・增益', tint:'azu',
    sil:'蹲坐＋上翹天線', h:1.42, w:0.86, wt:0.5,
    spd:1.0, turn:1.4, gait:1.5, rng:5.6, tTel:1.05, tAtk:0.50, tRec:1.30,
    q0:{lg:1, an:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'游擊', q:{an:0.82}, sp:1.44, sc:0.90},
          {n:'高桅', q:{an:1.38}, sp:0.66, sc:1.16}],
    parts:[
      pt('bev','dark', [0.70,0.40,0.72],[0,0.28,0]),
      pt('box','armor',[0.52,0.26,0.46],[0,0.56,-0.06],[-0.14,0,0]),
      pt('cyl','armor',[0.15,1.10,0.15],[0,1.06,0.18],[-0.36,0,0], function(P,o){
          P.sy *= o.q.an; P.y += (o.q.an-1)*0.44; P.z += (o.q.an-1)*0.17; }),
      pt('tor','glow', [0.62,0.62,0.55],[0,1.10,0.20],[HP-0.36,0,0], function(P,o){
          P.y += (o.q.an-1)*0.48; P.z += (o.q.an-1)*0.18;
          var k = 1 + 0.5*o.tel + 1.5*o.atk*(1-o.atk); P.sx*=k; P.sy*=k;
          P.rz += o.t*0.9; }),
      pt('oct','glow', [0.22,0.22,0.22],[0,1.62,0.38],null, function(P,o){
          P.y += (o.q.an-1)*0.88 + 0.05*Math.sin(o.t*2.4); P.z += (o.q.an-1)*0.35;
          var k = 1 + 1.6*o.tel; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('bev','trim', [0.24,0.24,0.58],[ 0.34,0.12,0.04], null, legSwing( 1,0.12,0.16)),
      pt('bev','trim', [0.24,0.24,0.58],[-0.34,0.12,0.04], null, legSwing(-1,0.12,0.16))
    ],
    ex:[ pt('tor','glowE',[0.90,0.90,0.4],[0,0.72,0.10],[HP,0,0], function(P,o){ P.rz -= o.t*0.7; }),
         pt('box','armorE',[0.60,0.10,0.34],[0,0.70,-0.14],[0.20,0,0]) ],
    pose:function(o){
      o.ry = 0.02*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.03 + 0.03*o.mv - o.tel*0.10;
    }
  },
  {
    id:'zunge', fam:'ladle', deep:1, code:'ZUNGE', zh:'舌', role:'深層・鞭擊', tint:'red',
    sil:'蹲坐＋上翹長舌', h:1.30, w:0.88, wt:1.1,
    spd:1.4, turn:1.8, gait:1.7, rng:4.4, tTel:0.55, tAtk:0.38, tRec:0.85,
    q0:{lg:1, tg:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'速鞭', q:{tg:0.78}, sp:1.40, sc:0.88},
          {n:'長舌', q:{tg:1.48}, sp:0.76, sc:1.14}],
    parts:[
      pt('bev','dark',[0.74,0.44,0.72],[0,0.28,0]),
      pt('oct','void',[0.52,0.40,0.52],[-0.12,0.50,0.16]),
      pt('box','armor',[0.22,1.30,0.10],[0.10,0.98,0.34],[-0.66,0,0.18], function(P,o){
          P.sy *= o.q.tg; P.y += (o.q.tg-1)*0.34; P.z += (o.q.tg-1)*0.26;
          P.rx += o.tel*0.50 - o.atk*1.30; }),
      pt('cone','glow',[0.20,0.44,0.20],[0.16,1.52,0.62],[-1.05,0,0.18], function(P,o){
          P.y += (o.q.tg-1)*0.66; P.z += (o.q.tg-1)*0.52;
          P.z += o.atk*0.75; P.y -= o.atk*0.55;
          var k = 1 + 0.9*o.tel; P.sx*=k; P.sz*=k; }),
      pt('bev','trim',[0.26,0.24,0.58],[ 0.34,0.12,0.04], null, legSwing( 1,0.12,0.18)),
      pt('bev','trim',[0.24,0.22,0.52],[-0.30,0.11,-0.06], null, legSwing(-1,0.11,0.20))
    ],
    ex:[ pt('cone','armorE',[0.18,0.44,0.18],[-0.30,0.62,0.02],[-0.5,0,-0.4]),
         pt('tor','glowE',[0.60,0.60,0.30],[-0.12,0.50,0.16],[0.4,0.2,0]) ],
    pose:function(o){ o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.06 + 0.05*o.mv - o.tel*0.16 + o.atk*0.28; o.rr = 0.06; }
  }
];
